export default __webpack_public_path__ + "static/media/icon-begin-assessment-new.b31e2a0a.svg";